import * as React from 'react';
import * as _ from 'lodash/fp';
import styled from 'styled-components';

import { getColor, getFontSize } from '@process-advisor/process-miner/shared/theme';
import { StyledTextField } from '@process-advisor/process-miner/discovery/styledTextField'

const Label = styled.div`
    margin-right: 10px;
    font-size: ${getFontSize('small')};
    color: ${getColor('blue')};
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    margin-right: 5px;
`;

type Props = {
    value: number;
    itemId?: number,
    label?: string;
    onChange?: any;
    onBlur?: any;
    className?: string,
    min?: number;
    max?: number;
    disabled?: boolean
};
//const handleChange = (value) => {onChange(itemId, {[name]: value});};

export const NumberInput: React.FC<Props> = ({
    value,
    itemId,
    onChange = _.noop,
    onBlur = _.noop,
    className,
    label,
    min,
    max,
    disabled,
}) => {
    const handleOnChange = (event) => {
        if (event.target.value >= 0) {onChange(itemId,event.target.value)};
    };

    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const finalValue = Number(event.target.value);

        if (min && finalValue < min) {
            onChange(min);
            return onBlur(min);
        }

        if (max && finalValue > max) {
            onChange(max);
            return onBlur(max);
        }

        onBlur(finalValue);
    };

    return (
        <Wrapper className={className}>
            { label && <Label>{label}</Label>}
            <StyledTextField
                disabled={disabled}
                onBlur={handleOnBlur}
                onChange={handleOnChange}
                value={value}
                variant="outlined"
                type="number" />
        </Wrapper>
    );
};
